import React from 'react';
import GitHubCalendar from 'react-github-calendar';
import "./githubStat.css"
const GitHubStat = () => {
    return (
        <section className='container'>
            <br />
            <h2>Github Statistics</h2>
            <div className='gitOption'>
                <div>
                    <img
                        id="github-stats-card"
                        src="https://github-readme-stats.vercel.app/api?username=Halderpritam123&theme=algolia&border_radius=15&hide_border=true"
                    />
                </div>
                <div>
                    <img
                        id="github-streak-stats"
                        src="https://github-readme-streak-stats.herokuapp.com?user=Halderpritam123&theme=gruvbox&hide_border=true&border_radius=15&dates=F5FFEF&background=1092D2&border=CFD4C1&stroke=FEFFF7&ring=E3EBE1&fire=E6EBEA&currStreakNum=EFFFFC&sideNums=FFFAEF&currStreakLabel=E6EBEA&sideLabels=ECFEFF)"
                    />
                </div>
                <div>
                    <img
                        id="github-top-langs"
                        src="https://github-readme-stats.vercel.app/api/top-langs/?username=Halderpritam123&langs_count=3&border_radius=15"
                    />
                </div>
            </div>
            <br />
            <div className="react-activity-calendar" >
            <GitHubCalendar
     username="Halderpritam123"
  blockSize={15}
  blockMargin={5}
      />
            </div>
        </section>
    );
}

export default GitHubStat;
